import React from 'react'
import { Button } from 'antd'
import AppointmentCard from 'components/AppointmentCard/AppointmentCard'
import { SHADOWS } from 'tokens'
import { Column } from './index.styled'
import { useNotesList } from './useNotesList'

export default function NotesListPanel() {
  const { pendingNotes, selectedPendingNoteId, handleNoteSelect, handleApproveForNote, isApproving } = useNotesList()

  if (pendingNotes.length === 0) {
    return (
      <Column>
        <div style={{ textAlign: 'center', padding: '40px', color: 'var(--color-text-secondary)' }}>
          No pending notes
        </div>
      </Column>
    )
  }

  return (
    <Column>
      {pendingNotes.map((note) => {
        const fullName = `${note.patient?.user?.firstname || ''} ${note.patient?.user?.lastname || ''}`.trim()
        const isSelected = selectedPendingNoteId === note.id

        return (
          <AppointmentCard
            key={note.id}
            name={fullName || ''}
            avatar={note.patient?.user?.profilePic}
            badges={
              <Button
                type="primary"
                loading={isApproving && selectedPendingNoteId === note.id}
                onClick={(e) => {
                  e.stopPropagation()
                  handleApproveForNote(note)
                }}
                style={{
                  minWidth: '156px',
                  height: '40px',
                  fontSize: 16,
                  fontWeight: 700,
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  borderRadius: 6,
                  boxShadow: SHADOWS.boxShadow,
                  // marginLeft: '20px',
                }}
              >
                Approve
              </Button>
            }
            onClick={() => handleNoteSelect(note)}
            cardProps={{
              style: {
                outline: isSelected ? '1px solid #000000' : 'none',
                outlineOffset: '-1px',
                cursor: 'pointer',
                marginBottom: '8px',
              },
            }}
            profileImageStyle={{
              marginLeft: '-1.8px',
            }}
            badgeContainerStyle={{
              marginRight: '-4px',
            }}
          />
        )
      })}
    </Column>
  )
}
